// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"9b950887","514":"9b161207"}[chunkId] + ".chunk.js";
};